
import React, { useState } from "react";
import { TikTokVideo } from "@/types/api";
import { DownloadContainer } from "./DownloadContainer";
import { DownloadDetailsModal } from "./DownloadDetailsModal";
import { useCollectionDownload } from "@/hooks/useCollectionDownload";

interface DownloadControlsProps {
  videos: TikTokVideo[];
  selected: string[];
  setSelected: (val: string[]) => void;
  isBulkDownloading: boolean;
  progressCounts: {
    total: number;
    in_progress: number;
    complete: number;
    failed: number;
    paused: number;
    pending: number;
  };
  onDownloadAll: () => void;
  isCompletedAll: boolean;
  collectionUrl: string;
  viewMode: 'grid' | 'table';
  onViewModeChange: (mode: 'grid' | 'table') => void;
  // These props need to be optional since they're not provided in VideoResults.tsx
  onPauseAll?: () => void;
  onResumeAll?: () => void;
  onCancelAll?: () => void;
  onDownloadZip?: () => void;
  onRetryFailedBulk?: () => void;
}

export function DownloadControls({
  videos,
  selected,
  setSelected,
  isBulkDownloading,
  progressCounts,
  onDownloadAll,
  isCompletedAll,
  collectionUrl,
  viewMode,
  onViewModeChange,
  onPauseAll = () => {},
  onResumeAll = () => {},
  onCancelAll = () => {},
  onDownloadZip = () => {},
  onRetryFailedBulk = () => {}
}: DownloadControlsProps) {
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const { isSubmitting, handleCollectionDownload } = useCollectionDownload(collectionUrl, videos);

  const handleSelectAll = (selectAll: boolean) => {
    if (selectAll) {
      setSelected(videos.map(v => v.id));
    } else {
      setSelected([]);
    }
  };

  const handleDownloadAllClick = () => {
    setShowDetailsModal(true);
    onDownloadAll();
  };

  return (
    <div className="space-y-6">
      <DownloadContainer
        videos={videos}
        selected={selected}
        onSelectAll={handleSelectAll}
        isDownloading={isBulkDownloading}
        collectionUrl={collectionUrl}
        viewMode={viewMode}
        onViewModeChange={onViewModeChange}
        onDownloadAll={handleDownloadAllClick}
      />

      <DownloadDetailsModal 
        open={showDetailsModal} 
        onClose={() => {
          setShowDetailsModal(false);
        }}
        onSubmit={handleCollectionDownload}
        isSubmitting={isSubmitting} 
      />
    </div>
  );
}
